import { useCustomDomain } from '../hooks/useCustomDomain'
import { useBreakpoint } from './useBreakpoint'

export const useHasSidebar = () => {
  const { customDomain } = useCustomDomain()
  const breakpoint = useBreakpoint()

  if (breakpoint === 'xs') return false

  return customDomain?.headerConfig?.headerType === 'sidebar'
}
